import MovieCard from "@/components/base/MovieCard";
import SectionHeading from "@/components/base/SectionHeading";
import { movies } from "@/mocks/movies";

export default function FeaturedSection() {
  const list = [...movies]
    .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))
    .slice(0, 8);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <SectionHeading
        title="编辑精选"
        subtitle="最新上线与编辑部推荐的国产影视作品，持续更新"
        morePath="/category/movie"
        moreLabel="浏览全部影片"
      />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {list.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}